import Any from './Any';
import Or from './Or';
import Custom from './Custom';
import Undefined from './Undefined';

const types = {
  Any,
  Or,
  Custom,
  Undefined,
};

export default types;
